export default class recruitManager {
    constructor() {
      /* 必要なDOM */
      this.selectTrigger = document.querySelectorAll('.c-input__select select');
      this.selectContent = document.querySelectorAll('.c-input__select__label');
      this.spTabTrigger = document.querySelectorAll('.p-recruit-tab_sp select');
      this.tabTrigger = document.querySelectorAll('#p-recruit-tab a');

    }
    init(){

        let _this = this;

        //セレクトボックス変更時の内部テキスト更新
        let _selectLength = this.selectTrigger.length;
        for(var i = 0 ; i < _selectLength ; i++){
          (function(arg) {
            _this.selectChange(arg);
            _this.selectTrigger[i].addEventListener('change', function() {
              _this.selectChange(arg);
            }, false);
          })(i);
        }

        //SP側、タブに相当するセレクトボックス変更時のページ内スクロール
        let _spTabLength = this.spTabTrigger.length;
        for(var i = 0 ; i < _spTabLength; i++){
          (function(arg2) {
            _this.spTabTrigger[i].addEventListener('change', function() {
              _this.spTabChange(arg2);
            }, false);
          })(i);
        }

        //PC側・上部横並びのナビクリック時のページ内スクロール
        let _tabLength = this.tabTrigger.length;
        for(var i = 0 ; i < _tabLength; i++){
          (function(arg3) {
            _this.tabTrigger[i].addEventListener('click', function() {
              _this.navChange(arg3);
            }, false);
          })(i);
        }

    }

    selectChange(number){ //セレクトボックス変更時の内部テキスト更新

      let _this = this;

      let _value = this.selectTrigger[number].value;
      let _optionText = document.querySelector('option[value="'+_value+'"]').textContent;
      this.selectContent[number].textContent = _optionText;

    }

    spTabChange(number){ //SP側、タブに相当するセレクトボックス変更時のページ内スクロール

      let _this = this;

      let _value = this.spTabTrigger[number].value;
      let _target = document.querySelector(_value);
      let rect = _target.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let headerHeight = document.getElementById('l-header').offsetHeight;
      let myTop = rect.top + scrollTop - headerHeight;
      TweenLite.to(window, 0.5, {scrollTo:myTop,onComplete: function(){
        // location.hash = _value;
        // return false;
      }});

    }

    navChange(number){ //PC側・上部横並びのナビクリック時のページ内スクロール

      let _this = this;

      let _value = this.tabTrigger[number].getAttribute('href');
      let _target = document.querySelector(_value);
      let rect = _target.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let headerHeight = document.getElementById('l-header').offsetHeight;
      let myTop = rect.top + scrollTop - headerHeight;
      console.log(myTop, _target, _value, headerHeight);
      TweenLite.to(window, 0.5, {scrollTo:myTop,onComplete: function(){
        // location.hash = _value;
        // return false;
      }});

    }
}
